import { Auth } from 'aws-amplify';

export async function getAccessToken(): Promise<void> {
  const session = await Auth.currentSession();
  const curToken = session.getAccessToken().getJwtToken();
}
